// import {getDictionary,getAreaTree} from '@/api/base'
import store from '../store'
import * as CryptoJS from 'crypto-js';

// 解析url参数
const parseUrl=src=>{
  const str=decodeURIComponent(src || location.href).split('?')[1];
  if(!str) return null
  const url = '?'+str; //获取url中"?"符后的字串
  let theRequest = new Object(); 
  if (url.indexOf("?") != -1) { 
    const str = url.substr(1); 
    const strs = str.split("&"); 
    for(let i = 0; i < strs.length; i ++) { 
      theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]); 
    } 
  }
  return theRequest;
}

// 下载文件流
function dataToFile (params) {
  let type = params.type;
  let fileName = params.fileName;
  let data = params.data;
  // 兼容 IE
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(new Blob([data]), fileName);
  } else {
    // 非IE 浏览器
    const url = window.URL.createObjectURL(new Blob([data], { type }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}`);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url); // 释放内存
  }
}

// // 获取字典项
// async function getDic(type){
//   const all={...store.state.dictionary};
//   const dictionary=store.state.dictionary[type];
//   if(dictionary) return dictionary;
//   const {data}=await getDictionary(type);
//   all[type]=data;
//   store.commit('setDictionary',all);
//   return data;
// }

// // 获取区域树
// async function getTree(params={}){
//   const areaTree=store.state.areaTree;
//   if(areaTree.length) return areaTree;
//   const {data}=await getAreaTree(params);
//   store.commit('setAreaTree',data.children);
//   return data.children;
// }

// 生成密码
// 密码的长度为 8-16 个字符。
// 密码包含大小写字母。
// 密码包含数字。
// 密码最少包含1种 ASCII 文本特殊字符字符： ` ~ ! @ # $ % ^ & * ( ) _ + - = { } | [ ] \ : " ; ' < > ? , . /
function createPwd(){
  const uppers=['Q','W','E','R','T','Y','U','I','O','P','A','S','D','F','G','H','J','K','L','Z','X','C','V','B','N','M'];
  const symbols=['`','~','!','@','#','$','%','^','&','*','(',')','-','+','_','=','{','}','|','[',']',':','"',';','','<','>','?',',','.','/'];
  let str='';
  const upperIndex=randomNum(0,25);
  str+=uppers[upperIndex];    // 第一个字符为大写字母
  const lowerIndex=randomNum(0,25);
  str+=uppers[lowerIndex].toLowerCase();    // 第二个字符为小写字母
  const numIndex=randomNum(0,9); 
  str+=numIndex;              // 第三个字符为数字
  const symbolIndex=randomNum(0,30);
  str+=symbols[symbolIndex];
  const num=randomNum(4,12);
  for(let i=0;i<num;i++){
    const lowerI=randomNum(0,25);
    if(randomNum(1,10)>8) str+=uppers[lowerI];
    else str+=uppers[lowerI].toLowerCase();
  }
  return str
}

//生成从minNum到maxNum的随机数
function randomNum(minNum,maxNum){ 
  switch(arguments.length){ 
    case 1: 
      return parseInt(Math.random()*minNum+1,10); 
    case 2: 
      return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
    default: 
      return 0; 
  } 
} 

const key = CryptoJS.enc.Utf8.parse('tdjyyxxytdjyyxxy')
const iv = CryptoJS.enc.Utf8.parse('tdjyyxxytdjyyxxy')

function decrypt(word){
  const base64 = CryptoJS.enc.Base64.parse(word)
  const src = CryptoJS.enc.Base64.stringify(base64)
  const decrypt = CryptoJS.AES.decrypt(src, key, {
    iv,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding
  })

  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

export {
  dataToFile,
  // getDic,
  // getTree,
  parseUrl,
  createPwd,
  decrypt
}